import React, {Component} from 'react'
import PropTypes from 'prop-types'
class Name extends Component {
    render() {
        const {name} = this.props

        return (
            <td className="Name">
                {name}
            </td>
        )
    }
}

Name.propTypes = {
    name: PropTypes.string
}

export default Name